import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface NivelExposicionPesvItem {
  id: number;
  descripcion: string;
  estado?: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

@Injectable({
  providedIn: "root",
})
export class NivelExposicionPesvService {
  private apiUrl = `${environment.apiUrl}/api`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<NivelExposicionPesvItem[]> {
    return this.http.get<NivelExposicionPesvItem[]>(`${this.apiUrl}/nivel_exposicion_pesv`, {
      withCredentials: true,
    });
  }

  getById(id: number): Observable<NivelExposicionPesvItem> {
    return this.http.get<NivelExposicionPesvItem>(`${this.apiUrl}/nivel_exposicion_pesv/${id}`, {
      withCredentials: true,
    });
  }
}
